import React from 'react';
import {ProtectedRoute} from '../../_common/components/Permissions';
import PriceQuoteDetails from '../pages';
import {pathnames as P} from '../../_common/constants/pathnames';
import {subjects as S} from '../../_common/constants/permissionSubjects';

export const priceQuoteDetailsRoute = (
  <ProtectedRoute
    subject={S.PRICE_QUOTE_DETAILS_PAGE}
    path={P.PRICE_QUOTE_DETAILS}
    component={PriceQuoteDetails}
  />
);
